// ==========================================================================
// groots Starter Kit
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================


// groots core !! DO NOT DELETE !!
// --------------------------------------------------

require('../../garden/_groots.js');

// groots buds .. Uncomment as needed
// --------------------------------------------------

if (typeof $ === 'undefined') window.$ = require('jquery');

// Utilities
// if (window.emulateObjectfit === undefined) require('../../garden/buds/objectfit-polyfill/gr-objectfit.js');
// if ($.fn.inliner === undefined) require('../../garden/buds/svg-inliner/gr-inline-svg.js');
// if ($.fn.equalizer === undefined) require('../../garden/buds/equalizer/gr-equalizer.js');
// if ($.fn.lazyloader === undefined) require('../../garden/buds/lazyloader/gr-lazy-loader.js');
// require('../../garden/buds/gr-snippets.js');


// Plugins
// if ($.fn.navigation === undefined) require('../../garden/buds/navigation/gr-navigation.js');
if ($.fn.customSelect === undefined) require('../../garden/buds/form-select/gr-form-select.js');
if ($.fn.customUpload === undefined) require('../../garden/buds/form-file-upload/gr-form-file-upload.js');
if ($.fn.formNormalize === undefined) require('../../garden/buds/form-normalize/gr-form-normalize.js');
// require('../../garden/buds/form-validation/gr-form-validation.js');
// if ($.fn.expander === undefined) require('../../garden/buds/expander/gr-expander.js');
// if ($.fn.accTabs === undefined) require('../../garden/buds/accordion-tabs/gr-accordion-tabs.js');
// if ($.fn.modal === undefined) require('../../garden/buds/modal/gr-modal.js');
// if ($.fn.videoBg === undefined) require('../../garden/buds/video-backgarden/gr-video-bg.js');
// if ($.fn.googlemaper === undefined) require('../../garden/buds/google-map/gr-googlemap.js');

( function() {
    "use strict";

    if(!$(".image-animate--left").hasClass("image-animate--left-anim")){
        $(".connection-image").hide();
        $(window).scroll(function() {
            var hT = $('#image-animation').offset().top,
                hH = $('#image-animation').outerHeight(),
                wH = $(window).height(),
                wS = $(this).scrollTop();
            if (wS > (hT+hH-wH) ){
                $(".image-animate--left").addClass("image-animate--left-anim");
                $(".image-animate--right").addClass("image-animate--right-anim");
                $(".connection-image").fadeIn( "slow" );
            }
        });
    }


})();
